module.exports = __webpack_public_path__ + "static/media/error_payment.870dd21e.png";